module.exports = __webpack_public_path__ + "img/shopcart_active.3f0a2016.svg";